/* This example requires Tailwind CSS v2.0+ */
import { ShieldCheckIcon, EmojiHappyIcon } from '@heroicons/react/outline';

const features = [
  {
    name: 'Easy to implement',
    description: (
      <>
        Implementing MFA no longer needs to be an error-prone headache. With
        Clerk, it's built in to work with the rest of your authentication flow,
        and even gives you Prebuilt-UIs so you don't need to reinvent the wheel.
      </>
    ),
    icon: EmojiHappyIcon
  },
  {
    name: 'Stops 99.9% of account takeovers',
    description: (
      <>
        Multifactor authentication is the <strong>best</strong> way to prevent
        account takeovers. Every application should allow users to enable this
        form of strong security.
      </>
    ),
    icon: ShieldCheckIcon
  }
];

export function Definitions() {
  return (
    <div className="pt-8 pb-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="md:grid md:grid-cols-2 md:gap-x-8 lg:gap-x-16">
          {features.map(feature => (
            <div key={feature.name} className="relative mt-8">
              <div>
                <div className="absolute flex h-12 w-12 items-center justify-center rounded-md bg-clerk-blue text-white">
                  <feature.icon className="h-6 w-6" aria-hidden="true" />
                </div>
                <h2 className="ml-16 text-xl font-medium leading-6 text-gray-900">
                  {feature.name}
                </h2>
              </div>
              <div className="mt-2 ml-16 text-lg text-gray-500 md:text-base lg:text-lg">
                {feature.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
